import React from 'react';
import { Container, CssBaseline } from '@mui/material';
import ImageCreator from './components/ImageCreator';

function App() {
  return (
    <>
      <CssBaseline />
      <ImageCreator />
    </>
  );
}

export default App; 